/**
 * @file: 删除
 * @author: xiaolong.huang@dmall.com
 */

import * as CubeTree from '../../cubeTree/index';
import { StageEvent } from '../../message/index';
import FrontCubeData from '../../frontCubeData/index';
import CodiSystem from '../../codiSystem/index';
import DragSyStem from '../../dragSyStem/index';
import Update from '../../update/index';
import NextTick from '../../utils/nextTick';
import Select from '../select/index';
import { findDelUpdateTargets, findDelTargetsAllSelect } from './toolkit';
import { updateAllShelfsClass } from '../../update/updateAllShelfsClass';
import { updateCubeList } from '../../update/updateCubeList';
import { updateEnd } from '../../update/updateEnd';

// 删除指定cube
function del(cubeIds: Array<CubeId>): void {
    if (!cubeIds.length) {
        return;
    }
    let delCubes: Array<CubeNode> = CubeTree.findByCubeIds(cubeIds);
    let needUpdateCubes: Array<CubeId> = findDelUpdateTargets(cubeIds);
    let allChildren: Array<CubeId> = CubeTree.findAllChildrenContainSelfByCubeIds(cubeIds);
    let hasShelf: boolean = CubeTree.listHasShelf(cubeIds);

    delCubes.forEach((delCube: CubeNode): void => {
        delCube.jView.remove();
    });

    // 对于选择器来说，需要手动查询出其子级，指定删除
    Select.removeGroup(allChildren);
    DragSyStem.delGroup(cubeIds);
    FrontCubeData.delGroup(cubeIds);
    CodiSystem.delGroup(cubeIds);
    CubeTree.delGroup(cubeIds);
    updateCubeList(needUpdateCubes);
    updateEnd();

    // 特殊处理，如果删除的对象里含有货架，则需要更新货架的标记class
    if (hasShelf) {
        updateAllShelfsClass();
    }
}

// 删除所有选中的cube
function delAllSelected(): void {
    let delCubes: Array<CubeId> = findDelTargetsAllSelect();

    del(delCubes);
}

export {
    del,
    delAllSelected
};
